// Vendor scripts
import 'bootstrap';

// Custom scripts
import './scripts/example';
import './scripts/banner-dismiss';
import './scripts/external-link-utm';
import './scripts/hero-carousel';
import initLeavingSite from './scripts/leaving-site.js';
import './scripts/animation';
import './scripts/appointment-modal';
import './scripts/chat-trigger';
import './scripts/mainNavigation';
import './scripts/accordionAnchors';
import './scripts/section-navigation';
import './scripts/tooltip';
import './scripts/location-carousel';
import './scripts/product-selector';
import { Fancybox } from "@fancyapps/ui";
window.Fancybox = Fancybox;

initLeavingSite();
